var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images)?_c('div',{class:['image-scroller w-full mb-4', _vm.wrapperClass]},[_c('div',{class:['flex inner-box', {'fullwidth': _vm.fullwidth}]},_vm._l((_vm.images),function(item,index){return _c('div',{key:`menuImages-${index}`,staticClass:"item"},[_c('img',{attrs:{"src":`${item.imageUrl}`,"alt":`${item.imageExplanation}`}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }